<template>
  <hm-content title="新增服务卡">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="product-ruleForm"
    >
      <el-form-item label="选择服务：" prop="serverId">
        <el-select
          clearable
          v-model="ruleForm.serverId"
          @change="getChargeType"
          placeholder="选择服务"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            v-for="item in serviceList.list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联服务商品：" prop="id">
        <el-select
          clearable
          v-model="ruleForm.id"
          placeholder="选择分类"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            v-for="item in virtualCommodityList"
            :key="item.id"
            :label="item.productName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="商品分类："
                    prop="id">
        <el-select clearable
                   v-model="ruleForm.id"
                   placeholder="选择分类"
                   size="small"
                   filterable
                   class="mr10">
          <el-option v-for="item in categoryList.list"
                     :key="item.id"
                     :label="item.categoryName"
                     :value="item.id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="服务卡名称：" prop="productName">
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="ruleForm.productName"
          placeholder="请输入服务卡名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="服务卡次数：" prop="totTime">
        <el-input
          class="mr10 ipt"
          size="small"
          @mousewheel.prevent.native
          clearable
          type="number"
          v-model.trim="ruleForm.totTime"
        ></el-input
        >次
      </el-form-item>
      <el-form-item label="服务卡标签：">
        <el-tag
          :key="tag"
          v-for="tag in ruleForm.productTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)"
          >{{ tag }}</el-tag
        >
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model.trim="inputValue"
          ref="saveTagInput"
          size="small"
          clearable
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        ></el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput"
          >+ 新标签</el-button
        >
      </el-form-item>
      <!--<el-form-item label="服务卡类型："
                    prop="productType"
                    v-show="chargeType !== ''">
        <div v-show="chargeType === 0"
             class="flex mr10">
          <div class="mr10">总次数：
            <el-input class="mr10 ipt"
                      size="small"
                      @mousewheel.prevent.native
                      clearable
                      type="number"
                      v-model.trim="ruleForm.totTime"></el-input>次
          </div>
          <div class="flex">每次消耗：
            <el-input size="small"
                      class="mr10 ipt"
                      @mousewheel.prevent.native
                      clearable
                      type="number"
                      v-model.trim="ruleForm.useTime"></el-input>次
          </div>
        </div>
        <div v-if="chargeType === 1"
             class="flex mr10">
          <div class="mr10">总时长：
            <el-input size="small"
                      class="mr10 ipt"
                      @mousewheel.prevent.native
                      clearable
                      type="number"
                      v-model.trim="ruleForm.totTime"></el-input>
            小时（{{ruleForm.totTime ? (ruleForm.totTime / 24).toFixed(2) : 0}}天）
          </div>
          <div class="flex">每次消耗：
            <el-input class="mr10 ipt"
                      size="small"
                      @mousewheel.prevent.native
                      clearable
                      type="number"
                      v-model.trim="ruleForm.useTime"></el-input>小时
          </div>
        </div>
      </el-form-item>-->
      <el-form-item label="服务卡规格：">
        <div class="flex">
          <div class="mr10">
            <el-input
              size="small"
              clearable
              v-model.trim="ruleForm.specification"
              class="mr10 ipt"
            ></el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="服务卡售价：" prop="price">
        <div>
          <el-input
            size="small"
            clearable
            @mousewheel.prevent.native
            type="number"
            v-model.trim="ruleForm.price"
            class="mr10 ipt"
          ></el-input
          >元
        </div>
      </el-form-item>
      <el-form-item label="会员售价：" prop="memberPrice">
        <div>
          <el-input
            size="small"
            clearable
            @mousewheel.prevent.native
            type="number"
            v-model.trim="ruleForm.memberPrice"
            class="mr10 ipt"
          ></el-input
          >元
        </div>
      </el-form-item>
      <el-form-item label="有效期：" prop="validityPeriod" ref="period">
        <el-radio-group v-model="ruleForm.validType">
          <el-radio :label="1">固定时长</el-radio>
          <el-radio :label="2">自定义日期</el-radio>
          <el-radio :label="0">不限</el-radio>
        </el-radio-group>
        <div v-show="ruleForm.validType === 2">
          <el-date-picker
            v-model="ruleForm.dateAndTime"
            type="daterange"
            size="small"
            @change="formatValidDate(2)"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
        <div v-show="ruleForm.validType === 1">
          购买<el-input
            size="small"
            @mousewheel.prevent.native
            type="number"
            clearable
            style="width: 70px"
            @change="formatValidDate(1)"
            v-model.trim="ruleForm.validSpaceDay"
            class="mr10 ipt"
          ></el-input
          >天后生效， 有效天数
          <el-input
            size="small"
            @mousewheel.prevent.native
            type="number"
            clearable
            style="width: 70px"
            @change="formatValidDate(1)"
            v-model.trim="ruleForm.validDay"
            class="mr10 ipt"
          ></el-input
          >天
        </div>
      </el-form-item>
      <el-form-item label="主图：" prop="listHeader">
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess"
          @crop-upload-fail="cropUploadFail"
          v-model="show"
          noCircle
          noSquare
          :width="345"
          :height="180"
          :headers="{ 'X-Access-Token': $token }"
          :params="{ fileDir: 'mallDecoration' }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
        <el-button
          type="primary"
          size="small"
          v-show="!listHeaderImgUrl"
          @click="toggleShow"
          >上传</el-button
        >
        <span class="form-tip">（主图仅可设置一张，图片尺寸建议345x180）</span>
        <div class="priview" v-if="listHeaderImgUrl">
          <img :src="listHeaderImgUrl" alt="主图" />
          <div class="opreat-wrapper flex item-center flex-center">
            <el-button type="text" @click="deleteListHeader">删除</el-button>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="轮播组图：" prop="listDetail">
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess"
          @crop-upload-fail="cropUploadFail"
          v-model="showDetail"
          noCircle
          noSquare
          :width="345"
          :height="180"
          :headers="{ 'X-Access-Token': $token }"
          :params="{ fileDir: 'mallDecoration' }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
        <el-button
          type="primary"
          size="small"
          v-show="uploadedDetailList.length < 6"
          @click="toggleShowDetail"
          >上传</el-button
        >
        <span class="form-tip"
          >（列表详情图可设置6张，图片尺寸建议345x180）</span
        >
        <ul class="flex flex-wrap">
          <li
            class="priview mr10"
            v-show="v"
            v-for="(v, i) in uploadedDetailList"
            :key="i"
          >
            <img :src="v" alt="列表详情图" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="setFirst(i)"
                >设为第一张图</el-button
              >
              <el-button type="text" @click="deleteListItem(i)">删除</el-button>
            </div>
          </li>
        </ul>
      </el-form-item>
      <el-form-item label="图文详情：" prop="imgTxt">
        <hm-rich-editor v-model="ruleForm.imgTxt" />
      </el-form-item>
      <el-form-item label="服务卡状态：">
        <div class="flex item-center">
          <el-switch
            style="display: block"
            v-model="ruleForm.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="上架"
            inactive-text="下架"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
          <span class="form-tip">（关闭后，不出现在服务内）</span>
        </div>
      </el-form-item>
      <el-form-item label="首页推荐：">
        <div class="flex item-center">
          <el-switch
            style="display: block"
            v-model="ruleForm.recommendStatus"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="推荐"
            inactive-text="不推荐"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
          <span class="form-tip">（推荐后将出现在小程序推荐列表内）</span>
        </div>
      </el-form-item>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')"
          >提交</el-button
        >
        <el-button size="small" @click="$router.back(-1)">返回</el-button>
      </div>
    </el-form>

    <div id="dragContainer">
      <div class="preview-wrapper" id="dragbleElement">
        <div class="flex flex-center">
          <el-button
            size="small"
            :type="isMininum ? 'danger' : 'danger'"
            round
            @click="minimum"
          >
            <span>{{ isMininum ? "点击预览" : "点击隐藏" }}</span>
          </el-button>
        </div>
        <transition name="fade">
          <div class="coupon-template" v-show="!isMininum">
            <div class="phone-container">
              <div class="phone-header flex-center flex item-center">
                服务卡详情
                <div class="setting flex">
                  <span class="hmicon icon-xuanxiang"></span>
                  <span class="hmicon icon-option_on"></span>
                </div>
              </div>
              <div class="phone-body">
                <div class="tabs flex flex-around">
                  <div
                    class="tab"
                    :class="{ active: activeTab === 0 }"
                    @click="activeTab = 0"
                  >
                    服务
                  </div>
                  <div
                    class="tab"
                    :class="{ active: activeTab === 1 }"
                    @click="activeTab = 1"
                  >
                    详情
                  </div>
                </div>
                <div v-show="activeTab === 0">
                  <el-carousel height="173px">
                    <el-carousel-item
                      v-for="(v, i) in uploadedDetailList"
                      :key="i"
                    >
                      <div class="img-wrapper">
                        <img :src="v" alt="列表详情图" />
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                  <div class="goods-info p10">
                    <div class="flex flex-between">
                      <div class="goods-name title">
                        {{ ruleForm.productName || "服务卡名" }}
                      </div>
                      <div class="goods-price danger">
                        ￥{{ ruleForm.price || "服务卡价格" }}
                      </div>
                    </div>
                    <div class="productTags flex flex-wrap">
                      <div
                        class="tag"
                        v-for="(v, i) in ruleForm.productTags"
                        :key="i"
                      >
                        {{ v }}
                      </div>
                      <div v-show="!ruleForm.productTags.length">标签</div>
                    </div>
                  </div>
                  <div class="goods-details p10 detail">
                    <div>
                      服务规格：
                      <span class="tag">{{ ruleForm.price || "规格" }}</span>
                    </div>
                    <div>服务有效期：{{ validDate }}</div>
                  </div>
                  <div class="container imgTxt p10">
                    <div class="text-center title">图文详情</div>
                    <div class="ql-container ql-snow">
                      <div class="ql-editor">
                        <div v-html="ruleForm.imgTxt"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="activeTab === 1">
                  <div class="ql-container ql-snow">
                    <div class="ql-editor">
                      <div v-html="ruleForm.imgTxt"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </hm-content>
</template>

<script>
import moment from "moment";
 import HmRichEditor from "@/components/HmRichEditor";
import { drag } from "@/utils/utils";
import { mapGetters } from "vuex";
import { getLoginUser } from "@/utils/auth";
import myUpload from "vue-image-crop-upload";

export default {
  components: {   HmRichEditor, myUpload },
  data() {
    const patternProductType = function(rule, val, callback) {
      if (this.chargeType === 0) {
        if (
          /^[1-9]\d*$/.test(this.ruleForm.totTime) &&
          /^[1-9]\d*$/.test(this.ruleForm.useTime) &&
          this.ruleForm.totTime >= this.ruleForm.useTime
        ) {
          callback();
        } else if (this.ruleForm.totTime < this.ruleForm.useTime) {
          return callback(new Error("每次消耗不能大于总次数"));
        } else {
          return callback(new Error("请输入大于0的正整数"));
        }
      } else if (this.chargeType === 1) {
        if (
          this.ruleForm.totTime > 0 &&
          this.ruleForm.useTime > 0 &&
          this.ruleForm.totTime >= this.ruleForm.useTime
        ) {
          callback();
        } else if (this.ruleForm.totTime < this.ruleForm.useTime) {
          return callback(new Error("每次消耗不能大于总时长"));
        } else {
          return callback(new Error("请输入大于0的数"));
        }
      }
    }.bind(this);
    const patternPrice = function(rule, val, callback) {
      if (this.ruleForm.price && this.ruleForm.price >= 0) {
        const isFloat = String(this.ruleForm.price).indexOf(".") > -1;
        if (
          Number.isInteger(+this.ruleForm.price) ||
          (isFloat && String(this.ruleForm.price).split(".")[1].length <= 2)
        ) {
          callback();
        } else {
          return callback(new Error("售价最多保留两位小数"));
        }
      } else {
        return callback(new Error("请输入售价，且售价应大于或等于0"));
      }
    }.bind(this);
    const patternMemberPrice = function(rule, val, callback) {
      if (this.ruleForm.memberPrice && this.ruleForm.memberPrice >= 0) {
        const isFloat = String(this.ruleForm.memberPrice).indexOf(".") > -1;
        if (
          (Number.isInteger(+this.ruleForm.memberPrice) ||
            (isFloat &&
              String(this.ruleForm.memberPrice).split(".")[1].length <= 2)) &&
          this.ruleForm.memberPrice <= this.ruleForm.price
        ) {
          callback();
        } else {
          return callback(
            new Error("会员价最多保留两位小数,且应小于或等于商品售价")
          );
        }
      } else {
        return callback(new Error("请输入会员价，且会员价应大于或等于0"));
      }
    }.bind(this);
    const patternvalidityPeriod = function(rule, val, callback) {
      const result1 =
        this.ruleForm.validType === 1 &&
        (!this.ruleForm.validDay ||
          this.ruleForm.validDay <= 0 ||
          !Number.isInteger(+this.ruleForm.validDay) ||
          (!this.ruleForm.validSpaceDay && this.ruleForm.validSpaceDay !== 0) ||
          this.ruleForm.validSpaceDay < 0 ||
          !Number.isInteger(+this.ruleForm.validSpaceDay));
      const result2 =
        this.ruleForm.validType === 2 &&
        (!this.ruleForm.dateAndTime || !this.ruleForm.dateAndTime.length);
      if (result1) {
        return callback(
          new Error("请输入延迟生效天数与有效天数，且有效天数应为大于0的整数")
        );
      } else if (result2) {
        return callback(new Error("请输入有效期"));
      } else {
        callback();
      }
    }.bind(this);
    const patternListHeader = function(rule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请上传主图"));
      }
      callback();
    }.bind(this);
    const patternListDetail = function(rule, val, callback) {
      if (this.uploadedDetailList.length <= 0) {
        return callback(new Error("请上传列表详情图"));
      }
      callback();
    }.bind(this);
    return {
      showDetail: false,
      show: false,
      inputVisible: false,
      isMininum: true,
      inputValue: "",
      activeTab: 0,
      type: 0,
      uploadedDetailList: [],
      listHeaderImgUrl: "",
      storeId: "",
      startDate: "",
      validDate: "",
      endDate: "",
      editorOption: {},
      chargeType: "",
      ruleForm: {
        id: "",
        productTags: [],
        serverId: "",
        productName: "",
        productType: 0,
        validType: 1,
        recommendStatus: 0,
        status: 1,
        totTime: "",
        useTime: 1,
        price: "",
        memberPrice: "",
        validDay: "",
        validSpaceDay: "",
        dateAndTime: "",
        imgTxt: ""
      },
      rules: {
        id: {
          required: true,
          message: "请关联服务商品",
          trigger: "change"
        },
        imgTxt: [
          { required: true, message: "请输入图文详情", trigger: "blur" }
        ],
        serverId: [
          { required: true, message: "请选择服务", trigger: "change" }
        ],
        productName: [
          { required: true, message: "请输入服务卡名", trigger: "blur" }
        ],
        productType: [
          { required: true, validator: patternProductType, trigger: "blur" }
        ],
        price: [{ required: true, validator: patternPrice, trigger: "blur" }],
        memberPrice: [
          { required: true, validator: patternMemberPrice, trigger: "blur" }
        ],
        totTime: {
          required: true,
          pattern: /^[1-9]\d*$/,
          trigger: "blur",
          message: "请输入大于0的正整数"
        },
        validityPeriod: [
          {
            required: true,
            validator: patternvalidityPeriod,
            trigger: "blur"
          }
        ],
        listHeader: [
          {
            required: true,
            validator: patternListHeader,
            trigger: "blur"
          }
        ],
        listDetail: [
          {
            required: true,
            validator: patternListDetail,
            trigger: "blur"
          }
        ]
      }
    };
  },
  computed: mapGetters(["serviceList", "categoryList", "virtualCommodityList"]),
  watch: {
    "ruleForm.validType": {
      handler(v) {
        this.$refs.period.clearValidate();
        if (v === 1) {
          this.ruleForm.dateAndTime = "";
        } else if (v === 2) {
          this.ruleForm.validDay = "";
          this.ruleForm.validSpaceDay = "";
        } else {
          this.validDate = "不限时间";
        }
        this.formatValidDate(v);
      },
      deep: true
    },
    "ruleForm.dateAndTime": {
      handler(val) {
        this.startDate = val ? moment(val[0]).format("YYYY-MM-DD") : "";
        this.endDate = val ? moment(val[1]).format("YYYY-MM-DD") : "";
      },
      deep: true
    }
  },
  mounted() {
    const { storeId } = getLoginUser();
    this.storeId = storeId;
    const dragbleElement = document.getElementById("dragbleElement");
    const dragContainer = document.getElementById("dragContainer");
    drag.startDrag(dragContainer, dragbleElement);
    this.$store.dispatch("queryServiceList", { pageSize: 999 });
    this.$store.dispatch("queryCategoryList", {
      pageSize: 999
    });
    this.$store.dispatch("queryVirtualCommodity");
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowDetail() {
      this.showDetail = !this.showDetail;
    },
    cropSuccess() {},
    /**
     * upload success
     *
     * [param] jsonData   服务器返回数据，已进行json转码
     * [param] field
     */
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      } else if (this.showDetail) {
        this.uploadedDetailList.push(jsonData.result);
      }
    },
    cropUploadFail() {},
    formatValidDate(type) {
      if (type === 0) {
        this.validDate = "不限时间";
      } else if (type === 1) {
        this.validDate = `购买后${this.ruleForm.validSpaceDay}天后生效，有效期${this.ruleForm.validDay}天`;
      } else if (type === 2) {
        const startDate = this.ruleForm.dateAndTime[0]
          ? moment(this.ruleForm.dateAndTime[0]).format("YYYY-MM-DD")
          : "";
        const endDate = this.ruleForm.dateAndTime[1]
          ? moment(this.ruleForm.dateAndTime[1]).format("YYYY-MM-DD")
          : "";
        this.validDate = `${startDate}-${endDate}`;
      }
    },
    minimum() {
      this.isMininum = !this.isMininum;
    },
    getChargeType(id) {
      this.chargeType = id
        ? this.serviceList.list.find(v => v.id === id).chargeType
        : "";
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose(tag) {
      this.ruleForm.productTags.splice(
        this.ruleForm.productTags.indexOf(tag),
        1
      );
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.ruleForm.productTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          const { categoryId, storeOutletId } = this.virtualCommodityList.find(
            v => v.id === this.ruleForm.id
          );
          params.relatedId = params.id;
          delete params.id;
          params = Object.assign(params, {
            categoryId,
            storeOutletId,
            detailImg: this.uploadedDetailList.join(","),
            listImg: this.listHeaderImgUrl,
            productTags: this.ruleForm.productTags,
            validStartDate: this.ruleForm.validType === 2 ? this.startDate : "",
            validEndDate: this.ruleForm.validType === 2 ? this.endDate : ""
          });
          this.$store.dispatch("addProduct", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 移除上传文件
    handleRemove() {
      this.listHeaderImgUrl = "";
    },
    deleteListHeader() {
      this.$refs.listHeaderUpload.handleRemove();
    },
    // 上传成功后的回调
    uploadSuccess(response) {
      this.listHeaderImgUrl = response.result;
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    // 上传错误
    uploadError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    // 上传前对文件的大小的判断
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpg";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 300;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 300k!",
          type: "warning"
        });
      }
      const isSize = new Promise((resolve, reject) => {
        let width = 345;
        let height = 180;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function() {
          let valid = img.width == width && img.height == height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          this.$message({
            message: "请上传345*180的图片!",
            type: "warning"
          });
          return Promise.reject();
        }
      );
      return (
        (extension || extension2 || extension3 || extension4) &&
        limitSize &&
        isSize
      );
    },
    handleRemoveListDetail(file) {
      if (typeof file === "number") {
        this.uploadedDetailList.splice(file, 1);
      } else {
        const index = this.uploadedDetailList.findIndex(
          v => v === file.response.result
        );
        this.uploadedDetailList.splice(index, 1);
      }
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning"
      });
    },
    uploadListDetailSuccess(response) {
      this.uploadedDetailList.push(response.result);
      this.$message({
        type: "success",
        message: "上传成功！"
      });
    },
    deleteListItem(i) {
      this.uploadedDetailList.splice(i, 1);
      // this.$refs.listDetailUpload.handleRemove(i);
    },
    setFirst(i) {
      let tmp = this.uploadedDetailList[0];
      this.uploadedDetailList[0] = this.uploadedDetailList[i];
      this.uploadedDetailList[i] = tmp;
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped lang="scss">
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.priview {
  position: relative;
  width: 375px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.preview-wrapper {
  position: fixed;
  top: 100px;
  right: 30px;
  width: 365px;
  z-index: 10;
}
</style>
